import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { auth, googleProvider } from '../config/firebase';
import { signInWithPopup } from 'firebase/auth';
import { FcGoogle } from 'react-icons/fc';
import './LoginPage.css';

const API_BASE = process.env.REACT_APP_API_URL
  ? (process.env.REACT_APP_API_URL.endsWith('/api')
      ? process.env.REACT_APP_API_URL
      : `${process.env.REACT_APP_API_URL}/api`)
  : 'https://stonari-official-backend.onrender.com/api';

const syncUserToMongo = async (user) => {
  try {
    const token = await user.getIdToken(true);
    await fetch(`${API_BASE}/users/profile`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({
        name: user.displayName || user.email.split('@')[0],
        email: user.email,
        photoURL: user.photoURL || '',
      }),
    });
  } catch (err) {
    console.error('MongoDB sync error:', err);
  }
};

const LoginPage = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleGoogle = async () => {
    setLoading(true);
    setError('');
    try {
      const cred = await signInWithPopup(auth, googleProvider);
      await syncUserToMongo(cred.user);
      navigate('/');
    } catch (err) {
      if (err.code !== 'auth/popup-closed-by-user') {
        setError('Google sign-in failed. Please try again.');
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-page">
      <div className="login-visual">
        <div className="login-visual__content">
          <h2>Welcome to<br /><em>Stonari Official</em></h2>
          <p>Discover premium fashion jewellery crafted for the bold and beautiful.</p>
          <div className="login-visual__dots">✦ ✦ ✦</div>
        </div>
      </div>

      <div className="login-form-panel">
        <div className="login-form-wrap">
          <Link to="/" className="login-logo">
            <span className="logo-text">STONARI</span>
            <span className="logo-sub">OFFICIAL</span>
          </Link>

          <h1>Sign In</h1>
          <p className="login-subtitle">Sign in to track orders and manage your account</p>

          {error && (
            <div className="login-error">
              {error}
            </div>
          )}

          <button className="google-btn" onClick={handleGoogle} disabled={loading}>
            <FcGoogle size={20} className="google-icon" /> 
            {loading ? 'Please wait...' : 'Continue with Google'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default LoginPage;
